var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2-Dashboard_Design-Final-Copy-2",
    "data-name": "2-Dashboard_Design-Final-Copy-2",
    transform: "translate(-32 -373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(32 373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M.5,0h17a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,2.5V.5A.5.5,0,0,1,.5,0Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M16.7,4a.3.3,0,0,1,.3.3h0V15.7a.3.3,0,0,1-.3.3H1.3a.3.3,0,0,1-.3-.3H1V4.3A.3.3,0,0,1,1.3,4H16.7ZM11.21,5.286H6.7a.3.3,0,0,0-.3.3h0V6.32a.3.3,0,0,0,.3.3H11.21a.3.3,0,0,0,.3-.3h0V5.586a.3.3,0,0,0-.3-.3Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.3d6042a254f03811dc6157e4d3183509.svg";
export { ForwardRef as ReactComponent };